import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Auth } from "aws-amplify";
import {
  Card,
  Container,
  Stack,
  Typography,
  TextField,
  TextareaAutosize,
  Tooltip,
  Button,
} from "@common-ui/ui";
import { Info } from "@mui/icons-material";
import { Grid } from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";

import { deleteServiceOption } from "../../services";

import { serviceSlice } from "../../reducers/serviceReducer";

export const ServiceOption = ({
  dispatch,
  data,
  serviceTypeId,
  orgId,
  setRefresh,
}) => {
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  let history = useHistory();
  const currentServiceOption = useSelector(
    (state) => state.service.currentServiceOption
  );

  useEffect(() => {
    async function fetchData() {
      try {
        await Auth.currentAuthenticatedUser();
      } catch (error) {
        history && history.push("/sign-in");
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [history]);

  const handleRemoveServiceOption = async () => {
    setIsLoading(true);
    try {
      await deleteServiceOption(data?.system_id, serviceTypeId, orgId);
      setOpen(false);
      setRefresh(true);
      setIsLoading(false);
    } catch (error) {
      alert(error);
      setIsLoading(false);
      history.go(0);
    }
  };

  return (
    <Card
      variant="outlined"
      sx={{
        p: 1,
        borderRadius: "10px",
        mb: 2,
      }}
    >
      <Container maxWidth="md" component="main">
        <Stack direction="column">
          <Grid container spacing={2}>
            <Grid item md={12} xs={12}>
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <div style={{ minWidth: "25%" }}>
                  <Typography variant="subtitle2">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                    Option
                    <span>
                      <Tooltip
                        placement="right"
                        arrow
                        title="Service Option has to be unique for this Service"
                      >
                        <Info sx={{ fontSize: 14, color: "#777777" }} />
                      </Tooltip>
                    </span>
                  </Typography>
                  <TextField
                    sx={{ mt: 1 }}
                    size="small"
                    autoComplete="off"
                    fullWidth
                    disabled={data ? true : false}
                    placeholder="Type"
                    margin="normal"
                    name="option"
                    onChange={(event) => {
                      dispatch(
                        serviceSlice.actions.updateServiceOption({
                          id: data ? data.system_id : currentServiceOption,
                          key: "name",
                          value: event.target.value,
                          hasData: data ? true : false,
                        })
                      );
                    }}
                    value={data?.name}
                    variant="outlined"
                  />
                </div>
                <div style={{ minWidth: "60%" }}>
                  <Typography variant="subtitle2">
                    <svg
                      width="16px"
                      height="16px"
                      viewBox="0 0 16 16"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g fillRule="evenodd">
                        <polygon
                          id="Shape"
                          fill="#EE2E24"
                          fillRule="nonzero"
                          points="7.17184265 4 8.82815735 4 8.5010352 7.164 11.1718427 5.308 12 6.692 9.00207039 8 12 9.308 11.1718427 10.692 8.5010352 8.836 8.82815735 12 7.17184265 12 7.4989648 8.836 4.82815735 10.692 4 9.308 6.99792961 8 4 6.692 4.82815735 5.308 7.4989648 7.164"
                        ></polygon>
                      </g>
                    </svg>
                    Description
                  </Typography>
                  <TextField
                    sx={{ mt: 1 }}
                    size="small"
                    autoComplete="off"
                    fullWidth
                    placeholder="Type"
                    margin="normal"
                    name="description"
                    onChange={(event) => {
                      dispatch(
                        serviceSlice.actions.updateServiceOption({
                          id: data ? data.system_id : currentServiceOption,
                          key: "description",
                          value: event.target.value,
                          hasData: data ? true : false,
                        })
                      );
                    }}
                    value={data?.description}
                    variant="outlined"
                  />
                </div>
              </Stack>
            </Grid>
            <Grid item md={12} xs={12}>
              <div>
                <Typography variant="subtitle2">Comments</Typography>
                <TextField
                  sx={{ mt: 1 }}
                  size="small"
                  fullWidth
                  placeholder="Type"
                  margin="normal"
                  onChange={(event) =>
                    dispatch(
                      serviceSlice.actions.updateServiceOption({
                        id: data ? data.system_id : currentServiceOption,
                        key: "comments",
                        value: event.target.value,
                        hasData: data ? true : false,
                      })
                    )
                  }
                  value={data?.comments}
                  InputProps={{
                    inputComponent: TextareaAutosize,
                    inputProps: { minRows: 4 },
                  }}
                  name="comments"
                  variant="outlined"
                />
              </div>
            </Grid>
          </Grid>
        </Stack>
        {data && (
          <Stack
            direction={{ xs: "column", md: "row" }}
            justifyContent="flex-start"
            spacing={{ xs: 1, md: 2 }}
            sx={{ py: 1 }}
          >
            {/* <div>
              <Button
                color="primary"
                disabled={
                  currentServiceOption?.option === "" ||
                  currentServiceOption?.description === ""
                }
                fullWidth
                size="small"
                type="submit"
                variant="contained"
                onClick={(event) => {}}
              >
                Edit
              </Button>
            </div> */}

            <div>
              <Button
                color="primary"
                disabled={
                  currentServiceOption?.option === "" ||
                  currentServiceOption?.description === ""
                }
                fullWidth
                size="small"
                type="submit"
                variant="contained"
                onClick={() => {
                  setOpen(true);
                }}
              >
                Remove
              </Button>
            </div>
          </Stack>
        )}
        <div>
          <Dialog
            open={open}
            onClose={() => setOpen(false)}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                {`Are you sure you want remove the Service Option ${data?.name}?`}
              </DialogContentText>
            </DialogContent>
            <DialogActions
              sx={
                {
                  // justifyContent: "space-between",
                }
              }
            >
              <Button
                onClick={handleRemoveServiceOption}
                variant="contained"
                disabled={isLoading}
              >
                Ok
              </Button>
              <Button onClick={() => setOpen(false)} variant="contained">
                Cancel
              </Button>
            </DialogActions>
          </Dialog>
        </div>
      </Container>
    </Card>
  );
};
